import { Box, styled, Typography } from '@mui/material'
import Container from '@mui/material/Container'
import Link from '@mui/material/Link'
import ViewTitle from '../../components/ViewTitle'
import config from '../../config'

const { notFoundImage } = config.assets

const Wrapper = styled('div')(() => ({
  marginTop: '48px',
  marginBottom: '48px',
  textAlign: 'center'
}))

const Splash = styled('div')(() => ({
  marginTop: '48px',
  marginBottom: '48px'
}))

const GoHomeButton = styled(Link)(({ theme }) => ({
  background: 'linear-gradient(158.55deg, #202CD3 5.3%, #02E39F 102.34%)',
  fontFamily: '"Outfit", Helvetica, sans-serif',
  fontWeight: 500,
  textTransform: 'none',
  textDecoration: 'none',
  borderRadius: '60px 60px 60px 60px',
  border: '1px solid #e1e1e1',
  color: '#fff',
  fontSize: '0.75rem',
  margin: 0,
  padding: '10px 30px 10px 30px',
  '&:hover': {
    backgroundColor: '#002D62',
    color: '#ffffff'
  },
  [theme.breakpoints.up('sm')]: {
    padding: '10px 30px 10px 30px'
  },
  [theme.breakpoints.up('md')]: {
    padding: '10px 60px 10px 60px',
    fontSize: '1.125rem'
  },
  [theme.breakpoints.up('xl')]: {
    padding: '10px 60px 10px 60px',
    fontSize: '1.5rem'
  }
})) as typeof Link

export default function NotFound() {
  return (
    <Wrapper>
      <ViewTitle title="Page Not Found" />
      <Container maxWidth="sm">
        <Splash>
          <img src={notFoundImage} alt="Page Not Found" width="100%" height="100%" />
        </Splash>
        <Typography variant="h3" color="#5B62FF" gutterBottom>
          Where Am I?
        </Typography>
        <Typography variant="h5">
          Welcome to 404 land. Where people go when technology has a hiccup. Relax, we&apos;ll have you back home in a jiff.
        </Typography>
        <Box sx={{ marginTop: '24px' }}>
          <GoHomeButton href="/">Take Me to Photobucket</GoHomeButton>
        </Box>
      </Container>
    </Wrapper>
  )
}
